import {ACCESSIBLE_COLOR} from '../../config/config';

const colorsPicker = {
    arrColor: ['10C2D1', '8700AF', 'FF8900', 'BB80C3', 'D11069', 'EBE205', 'FF4E00', 'CAD110', '5AD110', '1087D1', 'ed2df0', '07E6B3', 'C61010', 'F14E8d', 'e4e4e4', ACCESSIBLE_COLOR],
    currentColor: '',
    arrColorTemp: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    isAllColorsDisabled: false
};

export default colorsPicker;